<template>
  <div class="cloud-drillData">
    <div class="cloud-drillData-t">
      <div class="cloud-drillData-title" style="width: 100%">
        <div class="cloud-drillData-title-title">
          <img
            src="@/assets/images/groupTitlec.png"
            alt=""
            style="width: 100%; height: 4vh"
          />
          <p>全电脑三臂凿岩台车</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '3%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 96%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
      </div>
    </div>

    <div class="cloud-drillData-l">
      <div class="cloud-drillData-content-top">
        <div class="cloud-drillData-content-top-title">
          <img src="@/assets/images/tcar.png" alt="" />
          <p>台车工作状态</p>
        </div>

        <div class="cloud-drillData-content-top-content">
          <div style="margin-left: 5%; cursor: pointer" @click="stateClick">
            <div>
              <img
                src="@/assets/images/stop.png"
                alt=""
                v-if="stateFag === true"
              />
              <p v-if="stateFag === true">停止</p>
              <p
                style="
                  width: 15px;
                  height: 15px;
                  background: #1bffb1;
                  border-radius: 50%;
                  margin-top: 47px;
                  margin-left: 50px;
                "
                v-if="stateFag === false"
              ></p>
              <p v-if="stateFag === false" style="color: #1bffb1">启动</p>
            </div>
            <div>工作状态</div>
          </div>
          <div>
            <div>
              <img src="@/assets/images/start.png" alt="" />
              <p style="color: #1bffb1">正常</p>
            </div>
            <div>采集器通讯状态</div>
          </div>
        </div>

        <div class="cloud-drillData-content-top-content-item">
          <p>隧道名称</p>
          <p>铁路2标隧道</p>
        </div>
        <div class="cloud-drillData-content-top-content-item">
          <p>当前工作里程</p>
          <p>-</p>
        </div>
        <div class="cloud-drillData-content-top-content-item">
          <p>隧道总里程</p>
          <p>DK42+100</p>
        </div>
      </div>

      <div class="cloud-drillData-content-top-content-list">
        <ul>
          <li :class="{ active: itemActive == 0 }" @click="itemActive = 0">
            左臂
          </li>
          <li :class="{ active: itemActive == 1 }" @click="itemActive = 1">
            中臂
          </li>
          <li :class="{ active: itemActive == 2 }" @click="itemActive = 2">
            右臂
          </li>
        </ul>
        <div class="cloud-drillData-content-top-content-list-item">
          <div
            style="
              margin-left: 0px;
              margin-top: 0px;
              width: 300px;
              height: 300px;
            "
            id="armLeftDiv"
          >
            <div
              v-for="(item, index) in processedPoints"
              :key="index"
              class="floating-dot-yuandian"
              :style="{
                left: item.x + 'px',
                top: item.z + 'px',
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="cloud-drillData-r">
      <img src="@/assets/images/tacars.png" alt="" />
      <div
        class="cloud-drillData-r-content"
        style="top: 7.5vh; left: 3.8vw; width: calc(408 / 1920 * 100vw)"
        @click="centerAtiveClick"
      >
        <div>
          <div>
            <p
              style="
                width: 15px;
                height: 15px;
                background: #1bffb1;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: 10px;
                float: left;
              "
            ></p>
            <span style="line-height: 35px; margin-left: 10px"
              >中臂工作参数</span
            >
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p>灌装压力 <span>(bar)</span></p>
          <p>20.0</p>
          <p>水流量 <span>(l/min)</span></p>
          <p>20.0</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="centerAtive === true">
          <p>推进压力<span>(bar)</span></p>
          <p>/</p>
          <p>钻进速度 <span>(l/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="centerAtive === true">
          <p>回转压力 <span>(bar)</span></p>
          <p>/</p>
          <p>回转速度 <span>(m/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="centerAtive === true">
          <p>回转压力 <span>(bar)</span></p>
          <p>/</p>
          <p>回转速度 <span>(r/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="centerAtive === true">
          <p>缓冲压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻机位移 <span>(m)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="centerAtive === true">
          <p>泵后压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻进深度 <span>(m)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="centerAtive === true">
          <p>油气压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻孔长度<span>(mm)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="centerAtive === true">
          <p>定位泵压力 <span>(bar)</span></p>
          <p>/</p>
          <p>孔序进度 <span></span></p>
          <p>/</p>
        </div>
      </div>

      <div
        class="cloud-drillData-r-content"
        style="top: 9vh; left: 43.6vw; width: calc(408 / 1920 * 100vw)"
        @click="leftAtiveClick"
      >
        <div>
          <div>
            <p
              style="
                width: 15px;
                height: 15px;
                background: #1bffb1;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: 10px;
                float: left;
              "
            ></p>
            <span style="line-height: 35px; margin-left: 10px"
              >左臂工作参数</span
            >
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p>灌满压力 <span>(bar)</span></p>
          <p>20.0</p>
          <p>水流量 <span>(l/min)</span></p>
          <p>20.0</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="leftAtive === true">
          <p>推进压力<span>(bar)</span></p>
          <p>/</p>
          <p>钻进速度 <span>(l/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="leftAtive === true">
          <p>回转压力 <span>(bar)</span></p>
          <p>/</p>
          <p>回转速度 <span>(m/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="leftAtive === true">
          <p>回转压力 <span>(bar)</span></p>
          <p>/</p>
          <p>回转速度 <span>(r/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="leftAtive === true">
          <p>缓冲压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻机位移 <span>(m)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="leftAtive === true">
          <p>泵后压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻进深度 <span>(m)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="leftAtive === true">
          <p>油气压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻孔长度<span>(mm)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="leftAtive === true">
          <p>定位泵压力 <span>(bar)</span></p>
          <p>/</p>
          <p>孔序进度 <span></span></p>
          <p>/</p>
        </div>
      </div>

      <div
        class="cloud-drillData-r-content"
        style="top: 41.2vh; left: 4.4vw; width: calc(410 / 1920 * 100vw)"
        @click="rightAtiveClick"
      >
        <div>
          <div>
            <p
              style="
                width: 15px;
                height: 15px;
                background: #1bffb1;
                border-radius: 50%;
                margin-top: 10px;
                margin-left: 10px;
                float: left;
              "
            ></p>
            <span style="line-height: 35px; margin-left: 10px"
              >右臂工作参数</span
            >
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)">
          <p>灌满压力 <span>(bar)</span></p>
          <p>20.0</p>
          <p>水流量 <span>(l/min)</span></p>
          <p>20.0</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="rightAtive === true">
          <p>推进压力<span>(bar)</span></p>
          <p>/</p>
          <p>钻进速度 <span>(l/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="rightAtive === true">
          <p>回转压力 <span>(bar)</span></p>
          <p>/</p>
          <p>回转速度 <span>(m/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="rightAtive === true">
          <p>回转压力 <span>(bar)</span></p>
          <p>/</p>
          <p>回转速度 <span>(r/min)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="rightAtive === true">
          <p>缓冲压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻机位移 <span>(m)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="rightAtive === true">
          <p>泵后压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻进深度 <span>(m)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="rightAtive === true">
          <p>油气压力 <span>(bar)</span></p>
          <p>/</p>
          <p>钻孔长度<span>(mm)</span></p>
          <p>/</p>
        </div>
        <div style="background: rgba(0, 0, 0, 0.4)" v-if="rightAtive === true">
          <p>定位泵压力 <span>(bar)</span></p>
          <p>/</p>
          <p>孔序进度 <span></span></p>
          <p>/</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const BX_5_M = require("@/assets/pdf/test.pdf");
import dataJson from "./data.json";

// 引入路由实例
export default {
  name: "drillData",
  components: {},
  data() {
    return {
      itemActive: 0,
      processedPoints: [],
      rightAtive: true,
      leftAtive: false,
      centerAtive: false,
      stateFag: true,
    };
  },
  computed: {},
  mounted() {
    let that = this;
    this.processedPoints = dataJson.map((item) => {
      return {
        x: that.mapXValue(item.PointX),
        z: that.mapZValue(item.PointZ),
      };
    });
  },
  methods: {
    rightAtiveClick() {
      this.rightAtive = true;
      this.leftAtive = false;
      this.centerAtive = false;
    },
    leftAtiveClick() {
      this.rightAtive = false;
      this.leftAtive = true;
      this.centerAtive = false;
    },
    centerAtiveClick() {
      this.rightAtive = false;
      this.leftAtive = false;
      this.centerAtive = true;
    },
    stateClick() {
      this.stateFag = !this.stateFag;
    },
  },
  beforeDestroy() {},
};
</script>
<style scoped>
/* 引入字体 */
@font-face {
  font-family: "DS-Digital";
  src: url("../font/DS-DIGIB.TTF") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.cloud-drillData {
  width: 100%;
  height: 100%;
  text-align: left;

  > .cloud-drillData-t {
    position: relative;
    width: calc(1880 / 1920 * 100vw);
    height: calc(50 / 1080 * 100vh);
    top: 1vh;
    margin-left: 1vw;
    float: left;
    overflow: hidden;
    border-radius: 5px;
  }

  .cloud-drillData-title {
    position: absolute;
    top: 1vh;
    left: 0;
    width: 100%;
    height: calc(43 / 1080 * 100vh);
    background: rgba(0, 0, 0, 0.4);
    border-radius: 10px;

    .cloud-drillData-title-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;

      img {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
      }

      p {
        position: absolute;
        top: 0.3vh;
        left: 3.01vh;
        width: 100%;
        height: 2.5vh;
        margin: 0;
        padding: 0;
        font-size: 1rem;
        color: #fff;
        text-align: left;
      }
    }
  }

  .cloud-drillData-l {
    position: relative;
    width: calc(360 / 1920 * 100vw);
    height: calc(920 / 1080 * 100vh);
    top: 2vh;
    margin-left: 1vw;
    float: left;
    overflow: hidden;

    > .cloud-drillData-content-top {
      width: 99%;
      height: calc(400 / 1080 * 100vh);
      background: rgba(0, 0, 0, 0.4);

      > .cloud-drillData-content-top-title {
        width: 100%;
        height: calc(35 / 1080 * 100vh);
        background: #033da1 !important;
        border-radius: 0px 0px 0px 0px;

        > img {
          width: 2.5vh;
          height: auto;
          margin: 0;
          padding: 0;
          margin-top: 0.3vh;
          margin-left: 0.5vw;
          float: left;
        }

        > p {
          width: calc(100 / 1920 * 100vw);
          font-size: 0.8rem;
          color: #fff;
          text-align: left;
          float: left;
          margin: 0px;
          margin-left: 0.3vw;
          margin-top: 0.35vh;
        }
      }

      > .cloud-drillData-content-top-content {
        width: 100%;
        height: calc(156 / 1080 * 100vh);
        margin-top: 1.5vh;
        font-size: 0.8rem;

        > div {
          width: calc(158 / 1920 * 100vw);
          height: calc(156 / 1080 * 100vh);
          float: left;
          margin: 1%;
          background: linear-gradient(
            147deg,
            rgba(2, 58, 158, 0.8) 0%,
            rgba(2, 58, 158, 0.3) 100%
          );
          border-radius: 4px 4px 4px 4px;

          > div:nth-child(1) {
            width: 100%;
            height: calc(110 / 1080 * 100vh);
            text-align: center;

            > img {
              width: 18px;
              height: auto;
              margin: 0;
              padding: 0;
              margin-top: 5vh;
              margin-left: 2.5vw;
              float: left;
            }

            > p {
              font-size: 1rem;
              color: #a53636;
              text-align: center;
              margin: 0px;
              margin-top: 4.5vh;
              width: 40px;
              float: left;
            }
          }

          > div:nth-child(2) {
            width: 100%;
            text-align: center;
            color: #929292;
          }
        }
      }

      > .cloud-drillData-content-top-content-item {
        width: 90%;
        height: calc(36 / 1080 * 100vh);
        float: left;
        margin: 5%;
        margin-top: 3%;
        margin-bottom: 0%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        > p {
          width: 45%;
          height: calc(36 / 1080 * 100vh);
          font-size: 0.7rem;
          margin: 0px;
          padding: 5px;
          text-align: left;
          float: left;
        }

        > p:nth-child(1) {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        > p:nth-child(2) {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #fff;
          text-align: right;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    > .cloud-drillData-content-top-content-list {
      width: 100%;
      height: calc(450 / 1080 * 100vh);
      float: left;
      margin: 0px;
      margin-top: 3%;

      > ul {
        width: 100%;
        height: calc(70 / 1080 * 100vh);
        margin: 0px;
        padding: 0px;
        margin-top: -2%;
        list-style: none;

        > li {
          width: 31.7%;
          height: calc(45 / 1080 * 100vh);
          float: left;
          margin: 0px;
          margin-top: 3%;
          margin-bottom: 0%;
          margin-right: 1%;
          text-align: center;
          font-size: 0.8rem;
          line-height: calc(45 / 1080 * 100vh);
          border: 1px solid rgba(255, 255, 255, 0.1);
          background: linear-gradient(
            147deg,
            rgba(2, 58, 158, 0.2) 0%,
            rgba(2, 58, 158, 0.1) 100%
          );
          border-radius: 4px 10px 4px 4px;

          &.active {
            background: linear-gradient(
              147deg,
              rgba(2, 58, 158, 1.8) 0%,
              rgba(2, 58, 158, 0.3) 100%
            );
          }
        }
      }

      > .cloud-drillData-content-top-content-list-item {
        width: 100%;
        height: calc(400 / 1080 * 100vh);
        margin: 0px;
        margin-top: -2%;
        background: linear-gradient(
          147deg,
          rgba(2, 58, 158, 0.3) 0%,
          rgba(2, 58, 158, 0.2) 100%
        );

        > img {
          width: 60%;
          height: auto;
          margin-top: 5vh;
          margin-left: 20%;
        }
      }
    }
  }

  .cloud-drillData-r {
    position: relative;
    width: calc(1510 / 1920 * 100vw);
    height: calc(870 / 1080 * 100vh);
    top: 2vh;
    margin-left: 0.5vw;
    float: left;
    overflow: hidden;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.4);

    > img {
      width: calc(710 / 1920 * 100vw);
      height: auto;
      margin-top: calc(80 / 1080 * 100vh);
      margin-left: calc(370 / 1920 * 100vw);
    }

    > .cloud-drillData-r-content {
      position: absolute;
      width: calc(410 / 1920 * 100vw); /* 根据原设定调整 */
      height: auto; /* 调整为auto以适应内容的高度 */

      > div {
        display: flex;
        flex-wrap: nowrap; /* 防止子元素换行 */
        justify-content: space-between; /* 子元素间分配空间 */
        align-items: center; /* 垂直居中对齐 */
        padding: 0px; /* 可选：增加一些内边距 */
        margin: 0px;

        > p {
          height: calc(26 / 1080 * 100vh);
          flex: 1; /* 让每个p标签都能获得相等的空间 */
          min-width: 0; /* 允许p标签内的文本换行 */
          font-size: 0.8rem;
          line-height: normal; /* 使用正常的行高 */
          text-align: center;
          border: 1px solid rgba(255, 255, 255, 0.1);
          overflow: hidden; /* 隐藏溢出的内容 */
          white-space: nowrap; /* 防止文本换行 */
          text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
          margin: 0px;
          padding: 3px 10px;
          span {
            color: #145ce2;
          }
        }

        > p:nth-child(1),
        > p:nth-child(3) {
          flex: none; /* 禁用伸缩，尊重 width */
          width: 28%; /* 现在 width 才会生效 */
        }
      }

      > div:nth-child(1) {
        width: 100%;
        height: calc(30 / 1080 * 100vh);
        line-height: calc(30 / 1080 * 100vh);
        font-size: 0.8rem;
        background: linear-gradient(
          90deg,
          rgba(0, 87, 242, 0.8) 0%,
          rgba(0, 87, 242, 0.24) 100%
        );
        border-radius: 0px 0px 0px 0px;
        cursor: pointer;

        > p {
          width: calc(6 / 1920 * 100vw);
          height: calc(8 / 1080 * 100vh);
          background: #09f530;
          border-radius: 50%;
          margin: 0px;
          padding: 0px;
          margin: 0.4vw 0.2vw;
        }
      }
    }
  }

  > .floating-dot-yuandian {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 15px;
    height: 15px;
    background-color: rgb(247, 245, 243);
    /* 蓝色圆点 */
    border-radius: 50%;
    /* 圆形 */
    animation: float 3s ease-in-out infinite;
    /* 应用漂浮动画 */
  }
}
</style>